import React from 'react';
import Splash from 'components/Splash';
import Logo from 'static/images/logo.png';

const Loading = () => <Splash logoUrl={Logo} />;

export default Loading;
